export default "__VITE_ASSET__niovsoMx__"